module.exports = __webpack_public_path__ + "h5/img/logo2.8b6a3dfa.png";